import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";

import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import { pharmacyDashboardAPI, pharmacyDashboardOrdersAPI } from "../../api/pahrmacy";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon } from "../../components/Component";
import { Button, Col, Row } from "reactstrap";
import TotalSales from "../../components/partials/e-commerce/total-sales/TotalSales";
import StoreStatistics from "../../components/partials/default/StoreStatistics";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import Orders from "../../components/partials/e-commerce/orders/Orders";
import Customer from "../../components/partials/e-commerce/customers/Customer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import "bootstrap/dist/css/bootstrap.min.css";
import { hospitalDashboardAPI } from "../../api/Hospital";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { listHospitalAPI } from "../../api/dropdown";
import { Badge } from "reactstrap";

const HospitalDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);
  const [datas, setData] = useState([]);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      tableLoading: true,
      cardData: [],
      orderData: [],
      salesData: [],
      orders: [],
      customerData: [],
      storeStats: [],
      limit: 25,

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [onSearch, setonSearch] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [imageOpen, setImageOpen] = useState(false);
  const isLoading = watch("isLoading");
  const tableLoading = watch("tableLoading");
  const orderData = watch("orderData");
  const salesData = watch("salesData");
  const storeStats = watch("storeStats");
  const orders = watch("orders");
  const limit = watch("limit");
  const customerData = watch("customerData");
  const cardData = watch("cardData");
  const role = localStorage.getItem("role")


  const userId = localStorage.getItem("userId");

  const [column, setColumns] = useState([
    {
      name: "Hospital Name",
      selector: (row) => row?.name,
      sortable: true,
      wrap: true
      // width: "180px",
    },

    {
      name: "Contact Person",
      selector: (row) => row?.contactPerson,
      sortable: true,
      wrap: true,
      // width: "120px",
    },
    {
      name: "Mobile",
      selector: (row) => row?.mobile,
      sortable: true,
      // width: "120px",
    },

    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
      // width: "150px",
    },
    {
      name: "Address",
      sortable: true,
      wrap: true,
      cell: (row) => {
        const fullAddress = `${row?.addressLine1 || ""}, ${row?.addressLine2 || ""}, ${row?.district || ""}, ${row?.state || ""}, ${row?.country || ""} - ${row?.pincode || ""}`;

        return (
          <div
            title={fullAddress}
            style={{
              maxWidth: "150px",
              // whiteSpace: "nowrap",
              overflow: "hidden",
              // textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {truncateByWords(fullAddress, 2)}
          </div>
        );
      },
    },



    {
      name: "KYC Status",
      selector: (row) => row?.kyc_status,
      cell: (row) => (
        <Badge
          className="text-capitalize"
          color={`${row.kyc_status === "pending"
            ? "outline-warning"
            : row.kyc_status === "Approved"
              ? "outline-primary"
              : row.kyc_status === "In Review"
                ? "outline-info"
                : "outline-danger"
            }`}
        >
          {row.kyc_status}
        </Badge>
      ),
      sortable: true,
      // width: "100px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>,
      sortable: true,
      width: "100px",
    },
    {
      name: "Action",
      // width: "120px",
      cell: (row) => (
        <>
          {" "}
          {row?.kyc_status == "Approved" ? null : (
            <>
              <Button
                outline
                style={{ width: "50px" }}
                color={`primary`}
                size={`xs`}
                className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                id={`app-${row?.id}`}
                onClick={() => handleShowDetails(row)}
              >
                {" "}
                <Icon name="box" />
              </Button>
              {/* <TooltipComponent iconClass="card-hint" direction="top" id={`app-${row?.id}`} text="View and Approval" /> */}
              <Button
                id={`app-${row?.id}`}
                className="mx-1"
                outline
                color="warning"
                size="xs"
                onClick={() => handleEdit(row)}
              >
                <Icon name="edit" />
              </Button>
            </>
          )}
        </>
      ),
    },
  ]);

  useEffect(() => {
    gethospitalList();
  }, []);

  const gethospitalList = () => {
    setValue("isLoading", true);
    listHospitalAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setData(res.data.data);
          resetForm();
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      })
      .finally(() => {
        setValue("isLoading", false);
      });
  };

  const resetForm = () => { };

  const data = [
    {
      title: "Today's Sales",
      value: "$10,945",
      percentage: 4.63,
      trend: "up",
      color: "success",
      spark: [20, 25, 22, 30, 28, 35],
    },
    {
      title: "Today's Revenue",
      value: "$12,338",
      percentage: 2.34,
      trend: "down",
      color: "primary",
      spark: [30, 28, 26, 27, 25, 24],
    },
    {
      title: "Today's Customer",
      value: "$20,847",
      percentage: 4.63,
      trend: "up",
      color: "warning",
      spark: [10, 14, 13, 18, 17, 20],
    },
    {
      title: "Today's Expense",
      value: "$23,485",
      percentage: 1.34,
      trend: "up",
      color: "danger",
      spark: [40, 42, 41, 44, 43, 45],
    },
  ];

  const renderSparkline = (values, color) => {
    const max = Math.max(...values);
    const min = Math.min(...values);

    const points = values
      .map((v, i) => {
        const x = (i / (values.length - 1)) * 100;
        const y = 30 - ((v - min) / (max - min || 1)) * 30;
        return `${x},${y}`;
      })
      .join(" ");

    return (
      <svg width="90" height="30" viewBox="0 0 100 30">
        <polyline fill="none" stroke={`var(--bs-${color})`} strokeWidth="2" points={points} />
      </svg>
    );
  };


  const KPICardSkeleton = () => (
    <div className="col-xl-3 col-md-6">
      <div className="card shadow-sm h-100 p-3">
        <div className="card-body d-flex justify-content-between align-items-center">
          {/* Left content */}
          <div>
            {/* Title */}
            <Skeleton height={12} width={90} className="mb-2" />

            {/* Value row */}
            <div className="d-flex align-items-center gap-2 mb-2">
              <Skeleton height={15} width={110} />
              <Skeleton height={15} width={80} />
            </div>

            {/* Trend text */}
            <Skeleton height={12} width={130} />
          </div>
        </div>
      </div>
    </div>
  );

  const MiddleCardSkeleton = ({ height = 220 }) => (
    <div className="card shadow-sm h-100 p-4">
      <Skeleton width={120} height={10} className="mb-3" />
      <Skeleton width={180} height={40} className="mb-3" />
      <Skeleton width={180} height={10} className="mb-3" />

      <Skeleton width={180} height={15} className="mb-3" />

      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
        <Skeleton width={180} height={15} className="mb-3" />
        <Skeleton width={40} height={10} className="mb-3" />
      </div>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
        <Skeleton width={180} height={40} className="mb-3" />
        <Skeleton width={80} height={15} className="mb-" />
      </div>

      <div className="mt-5">
        <Skeleton width="100%" height={30} borderRadius={6} />
      </div>
    </div>
  );

  const MiddleCardStatic = ({ height = 120 }) => {
    return (
      <div className="card card-bordered h-100">
        <div className="card-inner">
          {/* Title */}
          <Skeleton width={120} height={18} />

          <div className="mt-3">
            {[1, 2, 3, 4].map((_, idx) => (
              <div key={idx} className="d-flex justify-content-between align-items-center mb-3">
                {/* Left text */}
                <div>
                  <Skeleton width={100} height={14} />
                  <Skeleton width={30} height={18} className="mt-1" />
                </div>

                {/* Right icon box */}
                <Skeleton width={40} height={40} borderRadius={8} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const MiddleCardOrder = ({ height = 100 }) => {
    return (
      <div className="card card-bordered h-100">
        <div className="card-inner">
          {/* Top row */}
          <div className="d-flex justify-content-between align-items-start">
            <Skeleton width={80} height={18} />

            <div className="text-end">
              <Skeleton width={40} height={14} />
              <Skeleton width={80} height={14} className="mt-1" />
            </div>
          </div>

          {/* Main number */}
          <div className="mt-2">
            <Skeleton width={60} height={36} />
          </div>

          {/* Chart placeholder */}
          <div className="mt-3">
            <Skeleton width="100%" height={30} borderRadius={6} />
          </div>
        </div>
      </div>
    );
  };

  const RecentOrdersSkeleton = ({ rows = 6 }) => {
    return (
      <div className="card card-bordered">
        {/* Header */}
        <div className="card-inner d-flex justify-content-between align-items-center">
          <Skeleton width={150} height={22} />
          <div className="d-flex gap-3">
            <Skeleton width={24} height={24} circle />
            <Skeleton width={24} height={24} circle />
          </div>
        </div>

        {/* Table */}
        <div className="nk-tb-list is-separate">
          {/* Table Head */}
          <div className="nk-tb-item nk-tb-head">
            {Array.from({ length: 8 }).map((_, i) => (
              <div className="nk-tb-col" key={i}>
                <Skeleton width={80} height={14} />
              </div>
            ))}
          </div>

          {/* Rows */}
          {Array.from({ length: rows }).map((_, idx) => (
            <div className="nk-tb-item" key={idx}>
              {/* Order No */}
              <div className="nk-tb-col">
                <Skeleton width={90} height={14} />
              </div>

              {/* Customer */}
              <div className="nk-tb-col">
                <div className="d-flex align-items-center gap-2">
                  <Skeleton width={36} height={36} circle />
                  <Skeleton width={120} height={14} />
                </div>
              </div>

              {/* Date */}
              <div className="nk-tb-col">
                <Skeleton width={90} height={14} />
              </div>

              {/* Amount */}
              <div className="nk-tb-col">
                <Skeleton width={60} height={14} />
              </div>

              {/* Address */}
              <div className="nk-tb-col">
                <Skeleton width={180} height={14} />
              </div>

              {/* Purchased */}
              <div className="nk-tb-col">
                <Skeleton width={70} height={14} />
              </div>

              {/* Pharmacy */}
              <div className="nk-tb-col">
                <Skeleton width={90} height={14} />
              </div>

              {/* Status */}
              <div className="nk-tb-col">
                <Skeleton width={70} height={14} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const handleEdit = (row) => {
    console.log("rowEdit", row);
    navigate(`/hospital-registration/hospital-basic-details`, { state: { hospitalid: row?.id, mode: "Edit" } });
  };

  const handleShowDetails = (row) => {
    console.log("rowEdit", row);
    navigate("/hospitalApprove", { state: { hospitalId: row?.id, mode: "Approval" } });
  };

  const truncateByWords = (text = "", wordLimit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + " ..."
      : text;
  };

  return (
    <>
      <Head title={"Hospital Dashboard"} />
      <div className="row g-gs pe-4 ps-4 pb-4" style={{ marginTop: "4.5rem" }}>
        <h3>Hospital Dashboard</h3>
        <div className="col-xxl-3 col-sm-3">
          <div className="card" style={{ background: "#446e35", border: "1px solid #d0e2ff" }}>
            <div className="nk-ecwg nk-ecwg6">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                    <h6 className="title" style={{ color: "white" }}>
                      Total Hospitals
                    </h6>
                  </div>
                </div>

                <div className="data">
                  <div className="data-group">
                    <div className="amount" style={{ color: "white", fontWeight: "bold" }}>
                      10
                    </div>

                    {/* <div className="nk-ecwg6-ck">
                      <canvas
                        className="ecommerce-line-chart-s3"
                        id="ipdIncome"
                        width={125}
                        height={50}
                        style={{
                          display: "block",
                          boxSizing: "border-box",
                          height: 40,
                          width: 100
                        }}
                      />
                    </div> */}
                  </div>

                  {/* <div className="info">
                    <span className="change up text-success">
                      <em className="icon ni ni-arrow-long-up" />
                      4.63%
                    </span>
                    <span> vs. last week</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-sm-3">
          <div className="card" style={{ background: "#658958", border: "1px solid #d0e2ff" }}>
            <div className="nk-ecwg nk-ecwg6">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                    <h6 className="title"style={{ color: "white" }}>
                      Departments</h6>
                  </div>
                </div>
                <div className="data">
                  <div className="data-group">
                    <div className="amount"style={{ color: "white", fontWeight: "bold" }}>
                      84</div>
                    {/* <div className="nk-ecwg6-ck">
                      <canvas
                        className="ecommerce-line-chart-s3"
                        id="opdIncome"
                        width={125}
                        height={50}
                        style={{
                          display: "block",
                          boxSizing: "border-box",
                          height: 40,
                          width: 100
                        }}
                      />
                    </div> */}
                  </div>
                  {/* <div className="info">
                    <span className="change down text-danger">
                      <em className="icon ni ni-arrow-long-down" />
                      2.34%
                    </span>
                    <span> vs. last week</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-sm-3">
          <div className="card"style={{ background: "#27411f", border: "1px solid #d0e2ff" }}>
            <div className="nk-ecwg nk-ecwg6">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title ">
                    <h6 className="title"style={{ color: "white" }}>Services</h6>
                  </div>
                </div>
                <div className="data">
                  <div className="data-group">
                    <div className="amount"style={{ color: "white", fontWeight: "bold" }}>35</div>
                    {/* <div className="nk-ecwg6-ck">
                      <canvas
                        className="ecommerce-line-chart-s3"
                        id="labIncome"
                        width={125}
                        height={50}
                        style={{
                          display: "block",
                          boxSizing: "border-box",
                          height: 40,
                          width: 100
                        }}
                      />
                    </div> */}
                  </div>
                  {/* <div className="info">
                    <span className="change up text-danger">
                      <em className="icon ni ni-arrow-long-up" />
                      4.63%
                    </span>
                    <span> vs. last week</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-sm-3">
           <div className="card" style={{ background: "#265415", border: "1px solid #d0e2ff" }}>
            <div className="nk-ecwg nk-ecwg6">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title ">
                    <h6 className="title"style={{ color: "white" }}>Facility</h6>
                  </div>
                </div>
                <div className="data">
                  <div className="data-group">
                    <div className="amount"style={{ color: "white", fontWeight: "bold" }}>35</div>
                    {/* <div className="nk-ecwg6-ck">
                      <canvas
                        className="ecommerce-line-chart-s3"
                        id="labIncome"
                        width={125}
                        height={50}
                        style={{
                          display: "block",
                          boxSizing: "border-box",
                          height: 40,
                          width: 100
                        }}
                      />
                    </div> */}
                  </div>
                  {/* <div className="info">
                    <span className="change up text-danger">
                      <em className="icon ni ni-arrow-long-up" />
                      4.63%
                    </span>
                    <span> vs. last week</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-sm-3">
          <div className="card" style={{ background: "#46603d", border: "1px solid #d0e2ff" }}>
            <div className="nk-ecwg nk-ecwg6">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                    <h6 className="title"style={{ color: "white" }}>Capacity</h6>
                  </div>
                </div>
                <div className="data">
                  <div className="data-group">
                    <div className="amount"style={{ color: "white", fontWeight: "bold" }}>89</div>
                    {/* <div className="nk-ecwg6-ck">
                      <canvas
                        className="ecommerce-line-chart-s3"
                        id="todayExpense"
                        width={125}
                        height={50}
                        style={{
                          display: "block",
                          boxSizing: "border-box",
                          height: 40,
                          width: 100
                        }}
                      />
                    </div> */}
                  </div>
                  {/* <div className="info">
                    <span className="change down text-danger">
                      <em className="icon ni ni-arrow-long-down" />
                      1.34%
                    </span>
                    <span> vs. last week</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-sm-3">
           <div className="card" style={{ background: "#264c18", border: "1px solid #d0e2ff" }}>
            <div className="nk-ecwg nk-ecwg6">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                   <h6 className="title"style={{ color: "white" }}>Machines</h6>
                  </div>
                </div>
                <div className="data">
                  <div className="data-group">
                    <div className="amount"style={{ color: "white", fontWeight: "bold" }}>89</div>
                    {/* <div className="nk-ecwg6-ck">
                      <canvas
                        className="ecommerce-line-chart-s3"
                        id="todayExpense"
                        width={125}
                        height={50}
                        style={{
                          display: "block",
                          boxSizing: "border-box",
                          height: 40,
                          width: 100
                        }}
                      />
                    </div> */}
                  </div>
                  {/* <div className="info">
                    <span className="change down text-danger">
                      <em className="icon ni ni-arrow-long-down" />
                      1.34%
                    </span>
                    <span> vs. last week</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-md-6 col-xxl-6">
          <div className="card h-100">
            <div className="card-inner">
              <div className="card-title-group mb-2">
                <div className="card-title">
                  <h6 className="title">Hospital Statistics</h6>
                </div>
              </div>
              <ul className="nk-store-statistics">
                <li className="item">
                  <div className="info">
                    <div className="title">Todays' Appointment</div>
                    <div className="count">470</div>
                  </div>
                  <em className="icon ni bg-blue-dim ni-list-index-fill" />
                </li>
                <li className="item">
                  <div className="info">
                    <div className="title">Doctors</div>
                    <div className="count">152</div>
                  </div>
                  <em className="icon bg-primary-dim ni ni-plus-medi" />
                </li>
                <li className="item">
                  <div className="info">
                    <div className="title">Patients</div>
                    <div className="count">2,327</div>
                  </div>
                  <em className="icon bg-info-dim ni ni-users" />
                </li>
                <li className="item">
                  <div className="info">
                    <div className="title">Nurses</div>
                    <div className="count">674</div>
                  </div>
                  <em className="icon bg-pink-dim ni ni ni-plus-fill-c" />
                </li>
                <li className="item">
                  <div className="info">
                    <div className="title">Department</div>
                    <div className="count">12</div>
                  </div>
                  <em className="icon bg-purple-dim ni ni-network" />
                </li>
              </ul>
            </div>
          </div>
        </div> */}
        {/* <div className="col-md-6 col-lg-4 col-xxl-4">
          <div className="card card-bordered card-full">
            <div className="card-inner-group">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                    <h6 className="title">New Patients</h6>
                  </div>
                  <div className="card-tools">
                    <a href="#" className="link">
                      View All
                    </a>
                  </div>
                </div>
              </div>
              <div className="card-inner card-inner-md">
                <div className="user-card">
                  <div className="user-avatar bg-primary-dim">
                    <span>AB</span>
                  </div>
                  <div className="user-info">
                    <span className="lead-text">Abu Bin Ishtiyak</span>
                    <span className="sub-text">info@softnio.com</span>
                  </div>
                  <div className="user-action">
                    <div className="drodown">
                      <a
                        href="#"
                        className="dropdown-toggle btn btn-icon btn-trigger me-n1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <em className="icon ni ni-more-h" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <ul className="link-list-opt no-bdr">
                          <li>
                            <a href="#">
                              <em className="icon ni ni-setting" />
                              <span>Action Settings</span>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <em className="icon ni ni-notify" />
                              <span>Push Notification</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-inner card-inner-md">
                <div className="user-card">
                  <div className="user-avatar bg-pink-dim">
                    <span>SW</span>
                  </div>
                  <div className="user-info">
                    <span className="lead-text">Sharon Walker</span>
                    <span className="sub-text">sharon-90@example.com</span>
                  </div>
                  <div className="user-action">
                    <div className="drodown">
                      <a
                        href="#"
                        className="dropdown-toggle btn btn-icon btn-trigger me-n1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <em className="icon ni ni-more-h" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <ul className="link-list-opt no-bdr">
                          <li>
                            <a href="#">
                              <em className="icon ni ni-setting" />
                              <span>Action Settings</span>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <em className="icon ni ni-notify" />
                              <span>Push Notification</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-inner card-inner-md">
                <div className="user-card">
                  <div className="user-avatar bg-warning-dim">
                    <span>GO</span>
                  </div>
                  <div className="user-info">
                    <span className="lead-text">Gloria Oliver</span>
                    <span className="sub-text">gloria_72@example.com</span>
                  </div>
                  <div className="user-action">
                    <div className="drodown">
                      <a
                        href="#"
                        className="dropdown-toggle btn btn-icon btn-trigger me-n1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <em className="icon ni ni-more-h" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <ul className="link-list-opt no-bdr">
                          <li>
                            <a href="#">
                              <em className="icon ni ni-setting" />
                              <span>Action Settings</span>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <em className="icon ni ni-notify" />
                              <span>Push Notification</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-inner card-inner-md">
                <div className="user-card">
                  <div className="user-avatar bg-success-dim">
                    <span>PS</span>
                  </div>
                  <div className="user-info">
                    <span className="lead-text">Phillip Sullivan</span>
                    <span className="sub-text">phillip-85@example.com</span>
                  </div>
                  <div className="user-action">
                    <div className="drodown">
                      <a
                        href="#"
                        className="dropdown-toggle btn btn-icon btn-trigger me-n1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <em className="icon ni ni-more-h" />
                      </a>
                      <div className="dropdown-menu dropdown-menu-end">
                        <ul className="link-list-opt no-bdr">
                          <li>
                            <a href="#">
                              <em className="icon ni ni-setting" />
                              <span>Action Settings</span>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <em className="icon ni ni-notify" />
                              <span>Push Notification</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <Col xxl="12">
          <Block>
            <MyDataTable title={"Hospital List"} isLoading={isLoading} columns={column} data={datas || []} />
          </Block>
        </Col>
      </div>


    </>
  );
};

export default HospitalDashboard;
